const baseStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",

  padding: "1.5rem 0 1.5rem 0",
  borderWidth: 2,
  borderColor: "#a3a3a3",
  borderStyle: "dashed",

  outline: "none",
  borderRadius: "0.75rem",
  transition: "border 200ms ease-in-out",

  width: "100%",
  height: "100%",

  minHeight: "40rem",
};

const focusedStyle = {
  borderColor: "#06b6d4",
};

const acceptStyle = {
  borderColor: "#22c55e",
};

const rejectStyle = {
  borderColor: "#ef4444",
};

export { baseStyle, focusedStyle, acceptStyle, rejectStyle };
